import { motion } from 'motion/react'
import { InteractiveDemo } from '../demo'
import { SectionHeading } from '../common/SectionHeading'
import type { LandingCopy, Language } from '../../models/LandingPage'

type InteractiveDemoSectionProps = {
  copy: LandingCopy
  language: Language
  reveal: object
}

export function InteractiveDemoSection({ copy, language, reveal }: InteractiveDemoSectionProps) {
  return <section id="demo" className="section demo">
    <div className="container">
      <motion.div {...reveal}>
        <SectionHeading eyebrow="02 — INTERACTIVE DEMO" title={copy.demoTitle} sub={copy.demoSub}/>
      </motion.div>
      <motion.div {...reveal} className="demo-wrap">
        {/* Protected feature: keep the real interactive demo here; do not replace it with AppMockup. */}
        <InteractiveDemo language={language}/>
      </motion.div>
    </div>
  </section>
}
